import { isProviderEntrySelected, type ProviderSelectionMatch } from "./providerSelectionKey";

export type SelectedParcelAccount = {
  provider_id: string | number;
  parcel_account_id: number;
};

export type PruneUnavailableProvidersResult = {
  providers: string[];
  parcel_accounts: SelectedParcelAccount[];
  changed: boolean;
};

export function pruneUnavailableProviders(
  selectedProviders: Array<string | number>,
  selectedParcelAccounts: SelectedParcelAccount[],
  providerOptions: ProviderSelectionMatch[],
): PruneUnavailableProvidersResult {
  const providers = selectedProviders
    .filter((entry) => providerOptions.some((provider) => isProviderEntrySelected(provider, [entry])))
    .map(String);
  const parcel_accounts = selectedParcelAccounts.filter((item) =>
    providerOptions.some((provider) => isProviderEntrySelected(provider, [item.provider_id])),
  );
  const changed =
    providers.length !== selectedProviders.length || parcel_accounts.length !== selectedParcelAccounts.length;

  return { providers, parcel_accounts, changed };
}
